import React, { useState, useEffect } from 'react';
import Draggable from 'react-draggable';
import { Modal, Row, Col, Space, Button, Typography } from 'antd';
import { CaretUpFilled, CaretDownFilled, CaretUpOutlined, CaretDownOutlined, CloseOutlined } from '@ant-design/icons';
import { JPYs, secondsToHms } from './Common';
import { calAmt, getCoeff, getProductionQuantityCoeff, getSagyoTimeCommon, getWeightMmCoeff } from './CommonIQ5';
import {
  Area_IQ5ManufactSizeKind,
  Bend_IQ5ManufactSizeKind,
  Cut_IQ5ManufactSizeKind,
  Debbur_IQ5ManufactSizeKind,
  Groove_IQ5ManufactSizeKind,
  Hole_IQ5ManufactSizeKind,
  Mount_IQ5ManufactSizeKind,
  Notch_IQ5ManufactSizeKind,
  Weight_IQ5ManufactSizeKind,
  WeldFinish_IQ5ManufactSizeKind,
} from './Constant';
import { ServiceClass, WorkType } from './enums';
import IQ3KouteiBetsuKesanshiki_Program from '../iq3/IQ3KouteiBetsuKesanshiki_Program';
import IQ3KouteiBetsuKesanshiki_Laser from '../iq3/IQ3KouteiBetsuKesanshiki_BlankLaser';
import IQ3KouteiBetsuKesanshiki_Kensa from '../iq3/IQ3KouteiBetsuKesanshiki_Kensa';
import IQ3KouteiBetsuKesanshiki_Shirring from '../iq3/IQ3KouteiBetsuKesanshiki_Shirring';
import IQ3KouteiBetsuKesanshiki_Bending from '../iq3/IQ3KouteiBetsuKesanshiki_Bending';
import IQ3KouteiBetsuKesanshiki_MenualBari from '../iq3/IQ3KouteiBetsuKesanshiki_MenualBari';
import IQ3KouteiBetsuKesanshiki_AutoBari from '../iq3/IQ3KouteiBetsuKesanshiki_AutoBari';
import IQ3KouteiBetsuKesanshiki_Yosetsu from '../iq3/IQ3KouteiBetsuKesanshiki_Yosetsu';
import IQ3KouteiBetsuKesanshiki_Hyoumen from '../iq3/IQ3KouteiBetsuKesanshiki_Hyoumen';
import IQ3KouteiBetsuKesanshiki_2jikakou from '../iq3/IQ3KouteiBetsuKesanshiki_2jikakou';
import IQ3KouteiBetsuKesanshiki_AdditionalProcess from '../iq3/IQ3KouteiBetsuKesanshiki_AdditionalProcess';
import IQ3KouteiBetsuKesanshiki_YosetsuFinish from '../iq3/IQ3KouteiBetsuKesanshiki_YosetsuFinish';
import IQ3KouteiBetsuKesanshiki_BlankPunch from '../iq3/IQ3KouteiBetsuKesanshiki_BlankPunch';
import IQ3KouteiBetsuKesanshiki_BlankCombi from '../iq3/IQ3KouteiBetsuKesanshiki_BlankCombi';

const EstimateFormulaModal = (props) => {
  // 2025-12-03
  const [showCostOrProcess, setShowCostOrProcess] = useState(0);
  // 原価
  const [showCostDetail, setShowCostDetail] = useState(true);
  const [showCostFormula, setShowCostFormula] = useState(true);
  // 見積もり
  const [showEstimateDetail, setShowEstimateDetail] = useState(true);
  const [showEstimateFormula, setShowEstimateFormula] = useState(true);
  // 見積もり
  const [showNextEstimateDetail, setShowNextEstimateDetail] = useState(true);
  const [showNextEstimateFormula, setShowNextEstimateFormula] = useState(true);
  // 材料費
  const [showEstimateMaterialDetail, setShowEstimateMaterialDetail] = useState(true);
  const [showEstimateMaterialFormula, setShowEstimateMaterialFormula] = useState(true);
  // 製造費
  const [showEstimateManufacturingDetail, setShowEstimateManufacturingDetail] = useState(true);
  const [showEstimateManufacturingFormula, setShowEstimateManufacturingFormula] = useState(true);
  // 粗利
  const [showGrossProfitDetail, setShowGrossProfitDetail] = useState(true);
  const [showGrossProfitFormula, setShowGrossProfitFormula] = useState(true);
  // 粗利率
  const [showGrossProfitMarginDetail, setShowGrossProfitMarginDetail] = useState(true);
  const [showGrossProfitMarginFormula, setShowGrossProfitMarginFormula] = useState(true);
  // 材料原価
  const [showMaterialCostDetail, setShowMaterialCostDetail] = useState(true);
  const [showMaterialCostFormula, setShowMaterialCostFormula] = useState(true);
  // 製造原価
  const [showManufacturCostDetail, setShowManufacturCostDetail] = useState(true);
  const [showManufacturCostFormula, setShowManufacturCostFormula] = useState(true);
  // 購入品
  const [showPurchaseDetail, setShowPurchaseDetail] = useState(true);
  const [showPurchaseFormula, setShowPurchaseFormula] = useState(true);
  // 費用
  const [showGeneralCostDetail, setShowGeneralCostDetail] = useState(true);
  const [showGeneralCostFormula, setShowGeneralCostFormula] = useState(true);
  // 表面処理
  const [showSurfaceCostDetail, setShowSurfaceCostDetail] = useState(true);
  const [showSurfaceCostFormula, setShowSurfaceCostFormula] = useState(true);
  // 管理
  const [showManagementCostDetail, setShowManagementCostDetail] = useState(true);
  const [showManagementCostFormula, setShowManagementCostFormula] = useState(true);

  // 工程別
  const [openIndices, setOpenIndices] = useState(new Set());
  const [isInitialized, setIsInitialized] = useState(false);

  //
  const getAllItemIndices = () => {
    const dataList = props.estimateData?.esIq5Info;
    if (dataList) {
      return new Set(dataList.map((_, index) => index));
    }
    return new Set();
  };

  //
  const closeAll = () => {
    if (showCostOrProcess === 0) {
      setShowCostDetail(false);
      setShowEstimateDetail(false);
      setShowGrossProfitDetail(false);
      setShowGrossProfitMarginDetail(false);
      setShowMaterialCostDetail(false);
      setShowManufacturCostDetail(false);
      setShowPurchaseDetail(false);
      setShowGeneralCostDetail(false);
      setShowSurfaceCostDetail(false);
      setShowManagementCostDetail(false);
    } else {
      setOpenIndices(new Set());

      setOpenProcessKeys(new Set());
    }
  };

  const openAll = () => {
    if (showCostOrProcess === 0) {
      setShowCostDetail(true);
      setShowEstimateDetail(true);
      setShowGrossProfitDetail(true);
      setShowGrossProfitMarginDetail(true);
      setShowMaterialCostDetail(true);
      setShowManufacturCostDetail(true);
      setShowPurchaseDetail(true);
      setShowGeneralCostDetail(true);
      setShowSurfaceCostDetail(true);
      setShowManagementCostDetail(true);
    } else {
      const allIndices = getAllItemIndices();
      setOpenIndices(allIndices);
    }
  };

  const showCostAccounting = () => {
    // 原価
    if (showCostDetail) {
      setShowCostDetail(false);
    } else {
      setShowCostDetail(true);
    }
    // 見積もり
    if (showEstimateDetail) {
      setShowEstimateDetail(false);
    } else {
      setShowEstimateDetail(true);
    }
    // 粗利
    if (showGrossProfitDetail) {
      setShowGrossProfitDetail(false);
    } else {
      setShowGrossProfitDetail(true);
    }
    // 粗利率
    if (showGrossProfitMarginDetail) {
      setShowGrossProfitMarginDetail(false);
    } else {
      setShowGrossProfitMarginDetail(true);
    }
    // 材料原価
    if (showMaterialCostDetail) {
      setShowMaterialCostDetail(false);
    } else {
      setShowMaterialCostDetail(true);
    }
    // 製造原価
    if (showManufacturCostDetail) {
      setShowManufacturCostDetail(false);
    } else {
      setShowManufacturCostDetail(true);
    }
    // 購入品
    if (showPurchaseDetail) {
      setShowPurchaseDetail(false);
    } else {
      setShowPurchaseDetail(true);
    }
    // 費用
    if (showGeneralCostDetail) {
      setShowGeneralCostDetail(false);
    } else {
      setShowGeneralCostDetail(true);
    }
    // 表面処理
    if (showSurfaceCostDetail) {
      setShowSurfaceCostDetail(false);
    } else {
      setShowSurfaceCostDetail(true);
    }
    // 管理
    if (showManagementCostDetail) {
      setShowManagementCostDetail(false);
    } else {
      setShowManagementCostDetail(true);
    }
  };

  // 原価
  const showCostFormulaDetail = () => {
    if (showCostFormula == true) {
      setShowCostFormula(false);
    } else {
      setShowCostFormula(true);
    }
  };

  // 見積もり
  const showEstimateFormulaDetail = () => {
    if (showEstimateFormula == true) {
      setShowEstimateFormula(false);
    } else {
      setShowEstimateFormula(true);
    }
  };

  // 見積もりNextStep
  const showNextEstimateFormulaDetail = () => {
    if (showNextEstimateFormula == true) {
      setShowNextEstimateFormula(false);
    } else {
      setShowNextEstimateFormula(true);
    }
  };

  // 材料費
  const showEstimateMaterialFormulaDetail = () => {
    if (showEstimateMaterialFormula == true) {
      setShowEstimateMaterialFormula(false);
    } else {
      setShowEstimateMaterialFormula(true);
    }
  };

  // 製造費
  const showEstimateManufacturingFormulaDetail = () => {
    if (showEstimateManufacturingFormula == true) {
      setShowEstimateManufacturingFormula(false);
    } else {
      setShowEstimateManufacturingFormula(true);
    }
  };

  // 粗利
  const showGrossProfitFormulaDetail = () => {
    if (showGrossProfitFormula == true) {
      setShowGrossProfitFormula(false);
    } else {
      setShowGrossProfitFormula(true);
    }
  };

  // 粗利率
  const showGrossProfitMarginFormulaDetail = () => {
    if (showGrossProfitMarginFormula == true) {
      setShowGrossProfitMarginFormula(false);
    } else {
      setShowGrossProfitMarginFormula(true);
    }
  };

  // 材料原価
  const showMaterialCostFormulaDetail = () => {
    if (showMaterialCostFormula == true) {
      setShowMaterialCostFormula(false);
    } else {
      setShowMaterialCostFormula(true);
    }
  };

  // 製造原価
  const showManufacturCostFormulaDetail = () => {
    if (showManufacturCostFormula == true) {
      setShowManufacturCostFormula(false);
    } else {
      setShowManufacturCostFormula(true);
    }
  };

  // 購入品
  const showPurchaseFormulaDetail = () => {
    if (showPurchaseFormula == true) {
      setShowPurchaseFormula(false);
    } else {
      setShowPurchaseFormula(true);
    }
  };

  //　費用
  const showGeneralCostFormulaDetail = () => {
    if (showGeneralCostFormula == true) {
      setShowGeneralCostFormula(false);
    } else {
      setShowGeneralCostFormula(true);
    }
  };

  // 表面処理
  const showSurfaceFormulaDetail = () => {
    if (showSurfaceCostFormula == true) {
      setShowSurfaceCostFormula(false);
    } else {
      setShowSurfaceCostFormula(true);
    }
  };

  // 管理
  const showManagementFormulaDetail = () => {
    if (showManagementCostFormula == true) {
      setShowManagementCostFormula(false);
    } else {
      setShowManagementCostFormula(true);
    }
  };

  // 係数
  const managementCoff = Number(props.estimateData?.estimateProducts?.otherProduct?.coeffManagements) || 1;
  const materialGrossProfitCoeff = Number(props.estimateData?.estimateProducts?.otherProduct?.coeffProducts) || 1;
  const customerCoff = Number(props.estimateData?.estimateProducts?.otherProduct?.coeffClient) || 1;
  const deliveryCofff = Number(props.estimateData?.estimateProducts?.otherProduct?.coeffDeliveryDates) || 1;
  const orderCoeff = Number(props.estimateData?.estimateProducts?.otherProduct?.coeffOrders) || 1;
  const purchaseCoeff = Number(props.estimateData?.estimateProducts?.otherProduct?.coeffPurchases) || 1;

  // 形鋼の材料原価
  const iQ5MaterialTotal =
    props.estimateData?.esIq5Info?.reduce((sum, item) => {
      const cost = item.materialCostTotalPrice || 0;
      return sum + cost;
    }, 0) || 0;

  // 板金の材料原価
  const iQ3MaterialTotal =
    props.estimateData?.esIq3Info?.reduce((sum, item) => {
      const cost = item.materialCostTotalPrice || 0;
      return sum + cost;
    }, 0) || 0;

  // 合計材料原価
  const combinedMaterialTotal = iQ5MaterialTotal + iQ3MaterialTotal;

  // 形鋼の製造原価
  const iQ5WorkTotal =
    props.estimateData?.esIq5Info?.reduce((sum, item) => {
      const cost = item.workCostTotalPrice || 0;
      return sum + cost;
    }, 0) || 0;

  // 板金の製造原価
  const iQ3WorkTotal =
    props.estimateData?.esIq3Info?.reduce((sum, item) => {
      const cost = item.workCostTotalPrice || 0;
      return sum + cost;
    }, 0) || 0;

  // 合計製造原価
  const combinedWorkTotal = iQ5WorkTotal + iQ3WorkTotal;

  // 板金の表面処理費
  const iQ3SurfaceTotal =
    props.estimateData?.esIq3Info?.reduce((sum, item) => {
      const cost = item.surfaceTotalPrice || 0;
      return sum + cost;
    }, 0) || 0;

  // 形鋼の購入品
  const iQ5PurchaseTotal =
    props?.estimateData?.esIq5Info?.reduce((sum, item) => {
      const cost = item.purchaseTotalPrice || 0;
      return sum + cost;
    }, 0) || 0;

  // 板金の購入品
  const iQ3PurchaseTotal =
    props?.estimateData?.esIq3Info?.reduce((sum, item) => {
      const cost = item.purchaseTotalPrice || 0;
      return sum + cost;
    }, 0) || 0;

  // 板金と形鋼の合計購入品
  const combinedPurchaseTotal = iQ5PurchaseTotal + iQ3PurchaseTotal;

  // 合計入品
  const totalPurchaseTotal = props?.estimateData?.estimateProducts?.purchaseTotalPrice || 0;

  // 親購入品
  const parentPurchaseTotal =
    totalPurchaseTotal > combinedPurchaseTotal ? totalPurchaseTotal - combinedPurchaseTotal : 0;

  // 費用
  const customCost =
    props?.estimateData?.epCustomCosts?.reduce((sum, item) => {
      // Ensure the property exists and is a number before adding
      const cost = item.totalPrice || 0;
      return sum + cost;
    }, 0) || 0;

  //
  const calculateTotalEstimate = () => {
    const iq3Material = iQ3MaterialTotal || 0;
    const iq5Material = iQ5MaterialTotal || 0;
    const totalMaterialCost = iq3Material + iq5Material;

    const totalWorkCost = props?.estimateData?.estimateProducts?.manufacturingCostTotalPrice || 0;
    const totalSurfaceCost = iQ3SurfaceTotal || 0;

    let totalProcessEstimate = totalWorkCost * (customerCoff + deliveryCofff + orderCoeff - 2) * managementCoff;

    // 表面処理費を足す。
    totalProcessEstimate = totalProcessEstimate + totalSurfaceCost * managementCoff;

    const totalPurchaseCost = iQ5PurchaseTotal || 0;
    const totalCustomCost = customCost || 0;

    const material = totalMaterialCost * materialGrossProfitCoeff * managementCoff;
    const manufacturing = totalProcessEstimate;
    const purchase = totalPurchaseCost * purchaseCoeff * managementCoff;
    const custom = totalCustomCost * managementCoff;

    const total = material + manufacturing + purchase + custom;

    return total || 0;
  };

  useEffect(() => {
    const dataList = props.estimateData?.esIq5Info;

    // Check if data is available and we haven't initialized yet
    if (dataList && dataList.length > 0 && !isInitialized) {
      // Create a Set containing all indices (0, 1, 2, ...)
      const allIndices = new Set(dataList.map((_, index) => index));

      // Set the state
      setOpenIndices(allIndices);

      // Mark as initialized so this doesn't run again on every render
      setIsInitialized(true);
    }
    // Dependency on data list is key here.
  }, [props.estimateData?.esIq5Info, isInitialized]);

  const toggleItem = (index) => {
    setOpenIndices((prevIndices) => {
      const newIndices = new Set(prevIndices);
      if (newIndices.has(index)) {
        newIndices.delete(index);
      } else {
        newIndices.add(index);
      }
      return newIndices;
    });
  };

  const isItemOpen = (index) => openIndices.has(index);

  // Details
  const [openProcessKeys, setOpenProcessKeys] = useState(new Set());

  const toggleProcessDetail = (itemIndex, processIndex) => {
    const newKey = `${itemIndex}-${processIndex}`;

    setOpenProcessKeys((prevKeys) => {
      const updatedKeys = new Set(prevKeys);

      if (updatedKeys.has(newKey)) {
        updatedKeys.delete(newKey);
      } else {
        updatedKeys.add(newKey);
      }
      return updatedKeys;
    });
  };

  // --- NEW STATE FOR LEVEL 3 ACCORDION ---
  // Stores keys like '0-0-0', '0-1-0', etc.
  const [openInputDetailKeys, setOpenInputDetailKeys] = useState(new Set());

  // --- NEW TOGGLE FUNCTION FOR LEVEL 3 ---
  const toggleProcessInputDetail = (processIndex, inputDetailIndex) => {
    // Note: We need a unique key. Assuming 'processIndex' is already unique enough
    // within the parent loop structure, we use that plus the new index.
    const newKey = `${processIndex}-${inputDetailIndex}`;

    setOpenInputDetailKeys((prevKeys) => {
      const updatedKeys = new Set(prevKeys);
      if (updatedKeys.has(newKey)) {
        updatedKeys.delete(newKey);
      } else {
        updatedKeys.add(newKey);
      }
      return updatedKeys;
    });
  };

  // --- NEW STATE FOR LEVEL 4 ACCORDION (e.g., detail content under device name) ---
  // Stores keys like '0-0-0-0', '0-1-0-0', etc. (Though we can simplify the key structure)
  const [openInputSubDetailKeys, setOpenInputSubDetailKeys] = useState(new Set());

  // --- NEW TOGGLE FUNCTION FOR LEVEL 4 ---
  const toggleInputSubDetail = (inputDetailKey, subDetailIndex) => {
    // Unique key: Combine the parent key (e.g., 'processIndex-inputDetailIndex') with the new index
    const newKey = `${inputDetailKey}-${subDetailIndex}`;

    setOpenInputSubDetailKeys((prevKeys) => {
      const updatedKeys = new Set(prevKeys);
      if (updatedKeys.has(newKey)) {
        updatedKeys.delete(newKey);
      } else {
        updatedKeys.add(newKey);
      }
      return updatedKeys;
    });
  };

  const getProcessName = (processId) => {
    const masterProcess = props?.processMasterInfo?.find((mst) => mst.id === processId);
    return masterProcess ? masterProcess.name : '不明な工程';
  };

  // 初期段取時間
  const getBasicTime = (deviceId) => {
    const basicTime = props?.deviceMasterInfo?.find((mst) => mst.id === deviceId).details?.prepBasicTime;
    return basicTime ? basicTime : 0;
  };

  // 形状区分係数
  const getSetupShapeCoeff = (deviceId, steelShapeId) => {
    const steelShapeCoeff = props?.deviceMasterInfo?.find((mst) => mst.id === deviceId).details?.setupShapeCoeff;
    const setupShapeCoeff = getCoeff(steelShapeCoeff, steelShapeId);
    return setupShapeCoeff ? setupShapeCoeff : 0;
  };

  // 材質区分係数
  const getMaterialClassificationCoeff = (deviceId, materialTypeId) => {
    const materialClassificationCoeff = props?.deviceMasterInfo?.find((mst) => mst.id === deviceId).details
      ?.materialClassificationCoeff;
    const materialClassCoeff = getCoeff(materialClassificationCoeff, materialTypeId);
    return materialClassCoeff ? materialClassCoeff : 0;
  };

  // //重量区分係数
  const getWeightClassificationCoeff = (deviceId, weight) => {
    const weightDetails = props?.deviceMasterInfo?.find((mst) => mst.id === deviceId).details;
    const weightClassificationCoeff = getWeightMmCoeff(
      weightDetails.weightClassificationCoeffThMaster,
      weightDetails.weightClassificationCoeffThItems,
      weight
    );
    return weightClassificationCoeff ? weightClassificationCoeff : 0;
  };

  // 切断
  const calculateCuttingCost = (curDevice, processInputDetail) => {
    let cutLength = 0;
    let kindNo = 0;
    let basicSagyoTime = 0;

    kindNo = processInputDetail?.kindNo;
    cutLength = processInputDetail?.cutLength || 0;

    const curDeviceDetails = curDevice?.details;

    const kindNm = curDeviceDetails.iQ5ManufactSizeInfo?.kinds?.find((k) => k.no === kindNo)?.name;

    if (kindNm === Cut_IQ5ManufactSizeKind?.[0]) {
      const singleProcessTimes = curDeviceDetails?.singleProcessTimeSec;
      basicSagyoTime = singleProcessTimes || 0;
    } else {
      const speedCoeff = getWeightMmCoeff(
        curDeviceDetails.processingSpeedMinThMaster,
        curDeviceDetails.processingSpeedMinThItems,
        cutLength
      );

      basicSagyoTime = (cutLength / speedCoeff) * 60;
    }

    basicSagyoTime = (processInputDetail.count || 1) * basicSagyoTime;

    return basicSagyoTime;
  };

  const calculateHoleDetailCost = (kindNo, processDetailTypeNo, holeLength, curDevice, workType) => {
    let basicSagyoTime = 0;

    basicSagyoTime = getSagyoTimeCommon(
      kindNo,
      processDetailTypeNo,
      holeLength,
      [curDevice],
      workType,
      Hole_IQ5ManufactSizeKind,
      'sizeProcessingTimeThMaster',
      'sizeProcessingTimeThItems',
      'processingSpeedThMaster',
      'processingSpeedThItems'
    );

    return basicSagyoTime;
  };

  const calculateNotchDetailCost = (kindNo, processDetailTypeNo, notchLength, curDevice, workType) => {
    let basicSagyoTime = 0;

    basicSagyoTime = getSagyoTimeCommon(
      kindNo,
      processDetailTypeNo,
      notchLength,
      [curDevice],
      workType,
      Notch_IQ5ManufactSizeKind,
      'processingSpeedThMaster',
      'processingSpeedThItems',
      '',
      ''
    );

    return basicSagyoTime;
  };

  const calculateBendDetailCost = (kindNo, processDetailTypeNo, bendLength, curDevice, workType) => {
    let basicSagyoTime = 0;

    basicSagyoTime = getSagyoTimeCommon(
      kindNo,
      processDetailTypeNo,
      bendLength,
      [curDevice],
      workType,
      Bend_IQ5ManufactSizeKind,
      'processingSpeedThMaster',
      'processingSpeedThItems',
      '',
      ''
    );

    return basicSagyoTime;
  };

  const calculateMountDetailCost = (kindNo, processDetailTypeNo, mountSize, curDevice, workType) => {
    let basicSagyoTime = 0;

    basicSagyoTime = getSagyoTimeCommon(
      kindNo,
      processDetailTypeNo,
      mountSize,
      [curDevice],
      workType,
      Mount_IQ5ManufactSizeKind,
      'sizeProcessingTimeThMaster',
      'sizeProcessingTimeThItems',
      'processingSpeedThMaster',
      'processingSpeedThItems'
    );

    return basicSagyoTime;
  };

  const calculateGrooveDetailCost = (kindNo, processDetailTypeNo, weldLength, curDevice, workType) => {
    let basicSagyoTime = 0;

    basicSagyoTime = getSagyoTimeCommon(
      kindNo,
      processDetailTypeNo,
      weldLength,
      [curDevice],
      workType,
      workType === WorkType.PaSteelDebbur ? Debbur_IQ5ManufactSizeKind : Groove_IQ5ManufactSizeKind,
      'processingSpeedThMaster',
      'processingSpeedThItems',
      '',
      ''
    );

    return basicSagyoTime;
  };

  const calculateWeldDetailCost = (kindNo, processDetailTypeNo, weldLength, curDevice, workType) => {
    let basicSagyoTime = 0;

    basicSagyoTime = getSagyoTimeCommon(
      kindNo,
      processDetailTypeNo,
      weldLength,
      [curDevice],
      workType,
      WeldFinish_IQ5ManufactSizeKind,
      'processingSpeedThMaster',
      'processingSpeedThItems',
      '',
      ''
    );

    return basicSagyoTime;
  };

  const calculateAreaDetailCost = (kindNo, processDetailTypeNo, area, curDevice, workType) => {
    let basicSagyoTime = 0;

    basicSagyoTime = getSagyoTimeCommon(
      kindNo,
      processDetailTypeNo,
      area,
      [curDevice],
      workType,
      Area_IQ5ManufactSizeKind,
      'areaProcessingTimeThMaster',
      'areaProcessingTimeThItems',
      '',
      ''
    );

    return basicSagyoTime;
  };

  const calculateWeightDetailCost = (kindNo, processDetailTypeNo, weight, curDevice, workType) => {
    let basicSagyoTime = 0;

    basicSagyoTime = getSagyoTimeCommon(
      kindNo,
      processDetailTypeNo,
      weight,
      [curDevice],
      workType,
      Weight_IQ5ManufactSizeKind,
      'kgProcessingTimeThMaster',
      'kgProcessingTimeThItems',
      '',
      ''
    );

    return basicSagyoTime;
  };

  // 板金
  const calDandoriTime = (elementCnt, deviceMst) => {
    if (elementCnt == 0) return 0;
    // 段取時間設定
    let prepElementThMaster = deviceMst?.details?.prepElementThMaster?.filter(
      (item) => (item.value == elementCnt || item.value > elementCnt) && !item.isOutOfRange
    );
    let prepElementThMasterCnt =
      prepElementThMaster?.length > 0 ? prepElementThMaster[0]?.no : deviceMst?.details?.prepElementThMaster[0]?.no;
    //　基本段取時間
    let dandoriTimeSec =
      prepElementThMasterCnt == 0
        ? 0
        : deviceMst?.details?.prepElementThItems?.filter(
            (item) => item.no == prepElementThMasterCnt && !item.isOutOfRange
          )?.[0]?.value;
    dandoriTimeSec = dandoriTimeSec ? dandoriTimeSec : 0;
    return dandoriTimeSec;
  };

  const calDandoriAmt = (dandoriTimeSec, mSetHRate) => {
    //段階時間
    let mSetTimeMin = dandoriTimeSec / 60;
    //段階時間＊時間チャージ
    let dandoriAmt = (mSetTimeMin * mSetHRate) / 60.0;
    dandoriAmt = dandoriAmt ? dandoriAmt : 0;
    return dandoriAmt;
  };

  const calSagyoTime = (elementCnt, workBasicTime, workTimeElementCoeff) => {
    if (elementCnt == 0) return 0;
    // 作業時間
    //1要素当たりの作業時間＊要素数＊作業時間係数
    let cSagyoTimeKensaSec = workBasicTime * elementCnt * workTimeElementCoeff;
    cSagyoTimeKensaSec = cSagyoTimeKensaSec ? cSagyoTimeKensaSec : 0;
    return cSagyoTimeKensaSec;
  };

  const calSagyoAmt = (cSagyoTimeSec, mWorkHRate) => {
    // 作業金額
    // 1部品当たりの作業時間
    let mWorkHTime = cSagyoTimeSec;
    let mWorkHTimeMin = mWorkHTime / 60;
    //　加工時間＊時間チャージ
    let cSagyoAmtKensa = (mWorkHTimeMin * mWorkHRate) / 60.0;
    cSagyoAmtKensa = cSagyoAmtKensa ? cSagyoAmtKensa : 0;
    return cSagyoAmtKensa;
  };

  return (
    (props?.isIQ5 || props?.isIQ3) && (
      <Modal
        maskClosable={false}
        open={props?.isIQ5 || props?.isIQ3}
        title={props?.detailModalTitle}
        footer={null}
        bodyStyle={{ height: '73vh', marginLeft: -17 }}
        width={1300}
        onOk={props?.detailDialogOk}
        onCancel={props?.detailDialogCancel}
        closeIcon={<CloseOutlined style={{ color: 'white' }} />}
        className={null}
        style={{ top: 85, left: 205 }}
        centered={true}
        modalRender={(modal) => (
          <Draggable handle=".ant-modal-header">
            <div>{modal}</div>
          </Draggable>
        )}
      >
        <div className="iq3-tab-div" style={{ height: '70vh', overflowY: 'auto' }}>
          <div className="overflow-auto kouteical KouteiCalculate" style={{ paddingTop: 5 }}>
            <Row className="mb-1" align="middle" justify="space-between">
              <Col>
                <Space size="small" style={{ paddingLeft: 2 }}>
                  <CaretUpFilled className="arrow-up-down" onClick={closeAll} />
                  <CaretDownFilled className="arrow-up-down" onClick={openAll} />
                </Space>
              </Col>
              <Col style={{ paddingRight: 2 }}>
                <Button
                  shape="round"
                  className={showCostOrProcess === 0 ? 'calculate-formula-active' : 'calculate-formula-btn'}
                  onClick={() => setShowCostOrProcess(0)}
                >
                  原価計算
                </Button>
                <Button
                  shape="round"
                  style={{
                    marginLeft: 8,
                  }}
                  className={showCostOrProcess === 1 ? 'calculate-formula-active' : 'calculate-formula-btn'}
                  onClick={() => setShowCostOrProcess(1)}
                >
                  工程別
                </Button>
              </Col>
            </Row>

            {/* 原価計算 */}
            <Row
              style={{ color: 'black', display: showCostOrProcess === 0 ? '' : 'none' }}
              className="oyabuhin oyabuhin-row "
              onClick={showCostAccounting}
            >
              <Col span={14} className="oyabuhin-col">
                <div style={{ display: 'flex' }}>
                  {showCostDetail ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  )}
                  <label style={{ marginLeft: 5, fontWeight: 700 }}>内訳</label>
                </div>
              </Col>
              <Col span={10} style={{ border: 'none' }} className="oyabuhin-col">
                <div>
                  <b>金額</b>
                </div>
              </Col>
            </Row>
            {/* 原価 */}
            <Row
              style={{
                color: 'black',
                display: showCostDetail && showCostOrProcess === 0 ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
              onClick={showCostFormulaDetail}
            >
              <Col span={14} className="oyabuhin-detail-col">
                <div style={{ display: 'flex' }}>
                  {showCostFormula ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  )}
                  <label style={{ marginLeft: 5, fontWeight: 700 }}>原価</label>
                </div>
              </Col>
              <Col span={10} className="oyabuhin-detail-col"></Col>
            </Row>

            <Row
              style={{
                color: 'black',
                display: showCostDetail && showCostOrProcess === 0 && showCostFormula ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
            >
              <Col span={14} className="oyabuhin-detail-col">
                <span style={{ marginLeft: 20 }}>材料原価+製造原価+表面処理+購入品+費用</span>
              </Col>
              <Col span={10} className="oyabuhin-detail-col" style={{ textAlign: 'left', paddingRight: 20 }}>
                {(() => {
                  const totalMaterialCost = props.estimateData?.estimateProducts?.materialCostTotalPrice || 0;
                  const totalWorkCost = props.estimateData?.estimateProducts?.manufacturingCostTotalPrice || 0;
                  const totalSurfaceCost = iQ3SurfaceTotal || 0;
                  const totalPurchaseCost = props.estimateData?.estimateProducts?.purchaseTotalPrice || 0;
                  const totalCustomCost = customCost || 0;
                  const totalCost = props.estimateData?.estimateProducts?.costTotalPrice || 0;

                  const formattedMaterialTotal = JPYs.format(Math.round(totalMaterialCost));
                  const formattedWorkTotal = JPYs.format(Math.round(totalWorkCost));
                  const formattedSurfaceTotal = JPYs.format(Math.round(totalSurfaceCost));
                  const formattedPurchaseTotal = JPYs.format(Math.round(totalPurchaseCost));
                  const formattedCustomCostTotal = JPYs.format(Math.round(totalCustomCost));
                  const formattedTotal = JPYs.format(Math.round(totalCost));

                  return `${formattedMaterialTotal} + ${formattedWorkTotal}+ ${formattedSurfaceTotal} + ${formattedPurchaseTotal} + ${formattedCustomCostTotal} = ${formattedTotal}`;
                })()}
              </Col>
            </Row>
            {/* 見積 */}
            <Row
              style={{
                color: 'black',
                display: showEstimateDetail && showCostOrProcess === 0 ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
              onClick={showEstimateFormulaDetail}
            >
              <Col span={14} className="oyabuhin-detail-col">
                <div style={{ display: 'flex' }}>
                  {showEstimateFormula ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  )}
                  <label style={{ marginLeft: 5, fontWeight: 700 }}>見積</label>
                </div>
              </Col>
              <Col span={10} className="oyabuhin-detail-col"></Col>
            </Row>

            <Row
              style={{
                color: 'black',
                display: showEstimateDetail && showCostOrProcess === 0 && showEstimateFormula ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
              onClick={showNextEstimateFormulaDetail}
            >
              <Col span={14} className="oyabuhin-detail-col">
                <div style={{ display: 'flex', marginLeft: 20 }}>
                  {showNextEstimateFormula ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  )}
                  <span style={{ marginLeft: 5 }}>材料費+製造費+購入品費+費用</span>
                </div>
              </Col>
              <Col span={10} className="oyabuhin-detail-col" style={{ textAlign: 'left', paddingRight: 20 }}>
                {(() => {
                  const iq3Material = iQ3MaterialTotal || 0;
                  const iq5Material = iQ5MaterialTotal || 0;
                  const totalMaterialCost = iq3Material + iq5Material;

                  const totalWorkCost = props.estimateData?.estimateProducts?.manufacturingCostTotalPrice || 0;
                  const totalSurfaceCost = iQ3SurfaceTotal || 0;

                  let totalProcessEstimate =
                    totalWorkCost * (customerCoff + deliveryCofff + orderCoeff - 2) * managementCoff;

                  // 表面処理費を足す。
                  totalProcessEstimate = totalProcessEstimate + totalSurfaceCost * managementCoff;

                  const totalPurchaseCost = iQ5PurchaseTotal || 0;
                  const totalCustomCost = customCost || 0;

                  const material = totalMaterialCost * materialGrossProfitCoeff * managementCoff;
                  const manufacturing = totalProcessEstimate;
                  const purchase = totalPurchaseCost * purchaseCoeff * managementCoff;
                  const custom = totalCustomCost * managementCoff;

                  const total = material + manufacturing + purchase + custom;

                  const formattedMaterialTotal = JPYs.format(Math.round(material));
                  const formattedWorkTotal = JPYs.format(Math.round(manufacturing));
                  const formattedPurchaseTotal = JPYs.format(Math.round(purchase));
                  const formattedCustomCostTotal = JPYs.format(Math.round(custom));
                  const formattedTotal = JPYs.format(Math.round(total));

                  return `${formattedMaterialTotal} + ${formattedWorkTotal} + ${formattedPurchaseTotal} + ${formattedCustomCostTotal} = ${formattedTotal}`;
                })()}
              </Col>
            </Row>
            {/* 材料費 */}
            <Row
              style={{
                color: 'black',
                display:
                  showEstimateDetail && showCostOrProcess === 0 && showEstimateFormula && showNextEstimateFormula
                    ? ''
                    : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
              onClick={showEstimateMaterialFormulaDetail}
            >
              <Col span={14} className="oyabuhin-detail-col">
                <div style={{ display: 'flex', marginLeft: 40 }}>
                  {showEstimateMaterialFormula ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  )}
                  <span style={{ marginLeft: 5 }}>材料費</span>
                </div>
              </Col>
              <Col span={10} className="oyabuhin-detail-col" style={{ textAlign: 'left', paddingRight: 20 }}></Col>
            </Row>
            {/* 材料費詳細 */}
            <Row
              style={{
                color: 'black',
                display:
                  showEstimateDetail &&
                  showCostOrProcess === 0 &&
                  showEstimateFormula &&
                  showNextEstimateFormula &&
                  showEstimateMaterialFormula
                    ? ''
                    : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
            >
              <Col span={14} className="oyabuhin-detail-col">
                <span style={{ marginLeft: 64 }}>材料原価 × 材料粗利係数 × 管理費係数</span>
              </Col>
              <Col span={10} className="oyabuhin-detail-col" style={{ textAlign: 'left', paddingRight: 20 }}>
                {(() => {
                  const iq3Material = iQ3MaterialTotal || 0;
                  const iq5Material = iQ5MaterialTotal || 0;
                  const totalMaterialCost = iq3Material + iq5Material;

                  const material = totalMaterialCost * materialGrossProfitCoeff * managementCoff;

                  const formattedMaterialTotal = JPYs.format(Math.round(material));
                  const formattedMaterial = JPYs.format(Math.round(totalMaterialCost));

                  return `${formattedMaterial} × ${materialGrossProfitCoeff} × ${managementCoff} = ${formattedMaterialTotal}`;
                })()}
              </Col>
            </Row>
            {/* 製造費 */}
            <Row
              style={{
                color: 'black',
                display:
                  showEstimateDetail && showCostOrProcess === 0 && showEstimateFormula && showNextEstimateFormula
                    ? ''
                    : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
              onClick={showEstimateManufacturingFormulaDetail}
            >
              <Col span={14} className="oyabuhin-detail-col">
                <div style={{ display: 'flex', marginLeft: 40 }}>
                  {showEstimateManufacturingFormula ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  )}
                  <span style={{ marginLeft: 5 }}>製造費</span>
                </div>
              </Col>
              <Col span={10} className="oyabuhin-detail-col" style={{ textAlign: 'left', paddingRight: 20 }}></Col>
            </Row>
            {/* 製造費詳細 */}
            <Row
              style={{
                color: 'black',
                display:
                  showEstimateDetail &&
                  showCostOrProcess === 0 &&
                  showEstimateFormula &&
                  showNextEstimateFormula &&
                  showEstimateManufacturingFormula
                    ? ''
                    : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
              onClick={showEstimateMaterialFormulaDetail}
            >
              <Col span={14} className="oyabuhin-detail-col">
                <span style={{ marginLeft: 64 }}>
                  (製造原価×(取引先係数＋納期係数＋受注形態-2)×管理費係数) + (表面処理費×管理費係数)
                </span>
              </Col>
              <Col span={10} className="oyabuhin-detail-col" style={{ textAlign: 'left', paddingRight: 20 }}>
                {(() => {
                  const totalWorkCost = props.estimateData?.estimateProducts?.manufacturingCostTotalPrice || 0;
                  const totalSurfaceCost = iQ3SurfaceTotal || 0;

                  let totalProcessEstimate =
                    totalWorkCost * (customerCoff + deliveryCofff + orderCoeff - 2) * managementCoff;

                  // 表面処理費を足す。
                  totalProcessEstimate = totalProcessEstimate + totalSurfaceCost * managementCoff;

                  const manufacturing = totalProcessEstimate;

                  const formattedWorkTotal = JPYs.format(Math.round(manufacturing));
                  const formattedManu = JPYs.format(Math.round(totalWorkCost));
                  const formattedSurface = JPYs.format(Math.round(totalSurfaceCost));

                  return `(${formattedManu} × (${customerCoff} + ${deliveryCofff} + ${orderCoeff} - 2) × ${managementCoff}) + (${formattedSurface} × ${managementCoff})  = ${formattedWorkTotal}`;
                })()}
              </Col>
            </Row>
            {/* 粗利 */}
            <Row
              style={{
                color: 'black',
                display: showGrossProfitDetail && showCostOrProcess === 0 ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
              onClick={showGrossProfitFormulaDetail}
            >
              <Col span={14} className="oyabuhin-detail-col">
                <div style={{ display: 'flex' }}>
                  {showGrossProfitFormula ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  )}
                  <label style={{ marginLeft: 5, fontWeight: 700 }}>粗利</label>
                </div>
              </Col>
              <Col span={10} className="oyabuhin-detail-col"></Col>
            </Row>
            <Row
              style={{
                color: 'black',
                display: showGrossProfitDetail && showCostOrProcess === 0 && showGrossProfitFormula ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
            >
              <Col span={14} className="oyabuhin-detail-col">
                <span style={{ marginLeft: 20 }}>見積-原価</span>
              </Col>
              <Col span={10} className="oyabuhin-detail-col" style={{ textAlign: 'left', paddingRight: 20 }}>
                {(() => {
                  const totalCost = props.estimateData?.estimateProducts?.costTotalPrice || 0;

                  const totalEstimate = calculateTotalEstimate();
                  const gross = totalEstimate > totalCost ? totalEstimate - totalCost : 0;

                  const formattedTotalCost = JPYs.format(Math.round(totalCost));
                  const formattedTotalEstimate = JPYs.format(Math.round(totalEstimate));
                  const formattedTotal = JPYs.format(Math.round(gross));

                  return `${formattedTotalEstimate} - ${formattedTotalCost} = ${formattedTotal}`;
                })()}
              </Col>
            </Row>
            {/* 粗利率 */}
            <Row
              style={{
                color: 'black',
                display: showGrossProfitMarginDetail && showCostOrProcess === 0 ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
              onClick={showGrossProfitMarginFormulaDetail}
            >
              <Col span={14} className="oyabuhin-detail-col">
                <div style={{ display: 'flex' }}>
                  {showGrossProfitMarginFormula ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  )}
                  <label style={{ marginLeft: 5, fontWeight: 700 }}>粗利率</label>
                </div>
              </Col>
              <Col span={10} className="oyabuhin-detail-col"></Col>
            </Row>
            <Row
              style={{
                color: 'black',
                display:
                  showGrossProfitMarginDetail && showCostOrProcess === 0 && showGrossProfitMarginFormula ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
            >
              <Col span={14} className="oyabuhin-detail-col">
                <span style={{ marginLeft: 20 }}>(粗利÷見積)×100</span>
              </Col>
              <Col span={10} className="oyabuhin-detail-col" style={{ textAlign: 'left', paddingRight: 20 }}>
                {(() => {
                  const totalCost = props.estimateData?.estimateProducts?.costTotalPrice || 0;

                  const totalEstimate = calculateTotalEstimate();
                  const gross = totalEstimate > totalCost ? totalEstimate - totalCost : 0;

                  let grossPercent = 0;
                  if (gross > 0 && totalEstimate > 0) {
                    grossPercent = (gross / totalEstimate) * 100;
                  }

                  const formattedGross = JPYs.format(Math.round(gross));
                  const formattedTotalEstimate = JPYs.format(Math.round(totalEstimate));

                  const formattedGrossPercent = grossPercent.toFixed(2);

                  return `(${formattedGross} ÷ ${formattedTotalEstimate}) × 100 = ${formattedGrossPercent}%`;
                })()}
              </Col>
            </Row>
            {/* 材料原価 */}
            <Row
              style={{
                color: 'black',
                display: showMaterialCostDetail && showCostOrProcess === 0 ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
              onClick={showMaterialCostFormulaDetail}
            >
              <Col span={14} className="oyabuhin-detail-col">
                <div style={{ display: 'flex' }}>
                  {showMaterialCostFormula ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  )}
                  <label style={{ marginLeft: 5, fontWeight: 700 }}>材料原価</label>
                </div>
              </Col>
              <Col span={10} className="oyabuhin-detail-col"></Col>
            </Row>
            <Row
              style={{
                color: 'black',
                display: showMaterialCostDetail && showCostOrProcess === 0 && showMaterialCostFormula ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
            >
              <Col span={14} className="oyabuhin-detail-col">
                <span style={{ marginLeft: 20 }}>板金材料費＋形鋼材料費</span>
              </Col>
              <Col span={10} className="oyabuhin-detail-col" style={{ textAlign: 'left', paddingRight: 20 }}>
                {(() => {
                  const iQ3Cost = iQ3MaterialTotal || 0;
                  const iQ5Cost = iQ5MaterialTotal || 0;
                  const totalCost = combinedMaterialTotal || 0;

                  const formattedIQ3 = JPYs.format(Math.round(iQ3Cost));
                  const formattedIQ5 = JPYs.format(Math.round(iQ5Cost));
                  const formattedTotal = JPYs.format(Math.round(totalCost));

                  return `${formattedIQ3} + ${formattedIQ5} = ${formattedTotal}`;
                })()}
              </Col>
            </Row>
            {/* 製造原価 */}
            <Row
              style={{
                color: 'black',
                display: showManufacturCostDetail && showCostOrProcess === 0 ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
              onClick={showManufacturCostFormulaDetail}
            >
              <Col span={14} className="oyabuhin-detail-col">
                <div style={{ display: 'flex' }}>
                  {showManufacturCostFormula ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  )}
                  <label style={{ marginLeft: 5, fontWeight: 700 }}>製造原価</label>
                </div>
              </Col>
              <Col span={10} className="oyabuhin-detail-col"></Col>
            </Row>
            <Row
              style={{
                color: 'black',
                display: showManufacturCostDetail && showCostOrProcess === 0 && showManufacturCostFormula ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
            >
              <Col span={14} className="oyabuhin-detail-col">
                <span style={{ marginLeft: 20 }}>
                  親部品製造原価＋板金加工原価(板金加工原価+表面処理費)＋形鋼加工原価
                </span>
              </Col>
              <Col span={10} className="oyabuhin-detail-col" style={{ textAlign: 'left', paddingRight: 20 }}>
                {(() => {
                  const parentCost = props.estimateData?.estimateProducts?.parentManufacturingCostTotalPrice || 0;
                  const iQ3WCost = props.estimateData?.estimateProducts?.iq3ManufacturingCostTotalPrice || 0;
                  const iQ5WCost = props.estimateData?.estimateProducts?.iq5ManufacturingCostTotalPrice || 0;
                  const total = parentCost + iQ3WCost + iQ5WCost;

                  const formattedParentCost = JPYs.format(Math.round(parentCost));
                  const formattedWorkIQ3 = JPYs.format(Math.round(iQ3WCost));
                  const formattedWorkIQ5 = JPYs.format(Math.round(iQ5WCost));
                  const formattedWorkTotal = JPYs.format(Math.round(total));

                  return `${formattedParentCost} + ${formattedWorkIQ3} + ${formattedWorkIQ5} = ${formattedWorkTotal}`;
                })()}
              </Col>
            </Row>
            {/* 購入品 */}
            <Row
              style={{
                color: 'black',
                display: showPurchaseDetail && showCostOrProcess === 0 ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
              onClick={showPurchaseFormulaDetail}
            >
              <Col span={14} className="oyabuhin-detail-col">
                <div style={{ display: 'flex' }}>
                  {showPurchaseFormula ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  )}
                  <label style={{ marginLeft: 5, fontWeight: 700 }}>購入品</label>
                </div>
              </Col>
              <Col span={10} className="oyabuhin-detail-col"></Col>
            </Row>
            <Row
              style={{
                color: 'black',
                display: showPurchaseDetail && showCostOrProcess === 0 && showPurchaseFormula ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
            >
              <Col span={14} className="oyabuhin-detail-col">
                <span style={{ marginLeft: 20 }}>親購入品＋板金購入品＋形鋼購入品</span>
              </Col>
              <Col span={10} className="oyabuhin-detail-col" style={{ textAlign: 'left', paddingRight: 20 }}>
                {(() => {
                  const iQ3Cost = iQ3PurchaseTotal || 0;
                  const iQ5Cost = iQ5PurchaseTotal || 0;
                  const parentCost = parentPurchaseTotal || 0;
                  const iq3And5Cost = combinedPurchaseTotal || 0;
                  const totalCost = parentPurchaseTotal + iq3And5Cost;

                  const formattedParent = JPYs.format(Math.round(parentCost));
                  const formattedIQ3 = JPYs.format(Math.round(iQ3Cost));
                  const formattedIQ5 = JPYs.format(Math.round(iQ5Cost));
                  const formattedTotal = JPYs.format(Math.round(totalCost));

                  return `${formattedParent} + ${formattedIQ3} + ${formattedIQ5} = ${formattedTotal}`;
                })()}
              </Col>
            </Row>
            {/* 表面処理 */}
            <Row
              style={{
                color: 'black',
                display: showSurfaceCostDetail && showCostOrProcess === 0 ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
              onClick={showSurfaceFormulaDetail}
            >
              <Col span={14} className="oyabuhin-detail-col">
                <div style={{ display: 'flex' }}>
                  {showSurfaceCostFormula ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  )}
                  <label style={{ marginLeft: 5, fontWeight: 700 }}>表面処理</label>
                </div>
              </Col>
              <Col span={10} className="oyabuhin-detail-col"></Col>
            </Row>
            <Row
              style={{
                color: 'black',
                display: showSurfaceCostDetail && showCostOrProcess === 0 && showSurfaceCostFormula ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
            >
              <Col span={14} className="oyabuhin-detail-col">
                <span style={{ marginLeft: 20 }}>合計表面処理</span>
              </Col>
              <Col span={10} className="oyabuhin-detail-col" style={{ textAlign: 'left', paddingRight: 20 }}>
                {(() => {
                  const cusCost = iQ3SurfaceTotal || 0;
                  const formattedTotal = JPYs.format(Math.round(cusCost));

                  return `${formattedTotal}`;
                })()}
              </Col>
            </Row>
            {/* 費用 */}
            <Row
              style={{
                color: 'black',
                display: showGeneralCostDetail && showCostOrProcess === 0 ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
              onClick={showGeneralCostFormulaDetail}
            >
              <Col span={14} className="oyabuhin-detail-col">
                <div style={{ display: 'flex' }}>
                  {showGeneralCostFormula ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  )}
                  <label style={{ marginLeft: 5, fontWeight: 700 }}>費用</label>
                </div>
              </Col>
              <Col span={10} className="oyabuhin-detail-col"></Col>
            </Row>
            <Row
              style={{
                color: 'black',
                display: showGeneralCostDetail && showCostOrProcess === 0 && showGeneralCostFormula ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
            >
              <Col span={14} className="oyabuhin-detail-col">
                <span style={{ marginLeft: 20 }}>合計費用</span>
              </Col>
              <Col span={10} className="oyabuhin-detail-col" style={{ textAlign: 'left', paddingRight: 20 }}>
                {(() => {
                  const cusCost = customCost || 0;
                  const formattedTotal = JPYs.format(Math.round(cusCost));

                  return `${formattedTotal}`;
                })()}
              </Col>
            </Row>

            {/* 管理 */}
            <Row
              style={{
                color: 'black',
                display: showManagementCostDetail && showCostOrProcess === 0 ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
              onClick={showManagementFormulaDetail}
            >
              <Col span={14} className="oyabuhin-detail-col">
                <div style={{ display: 'flex' }}>
                  {showManagementCostFormula ? (
                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  ) : (
                    <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                  )}
                  <label style={{ marginLeft: 5, fontWeight: 700 }}>管理</label>
                </div>
              </Col>
              <Col span={10} className="oyabuhin-detail-col"></Col>
            </Row>
            <Row
              style={{
                color: 'black',
                display: showManagementCostDetail && showCostOrProcess === 0 && showManagementCostFormula ? '' : 'none',
              }}
              className="calculate-formula-detail oyabuhin-row"
            >
              <Col span={14} className="oyabuhin-detail-col">
                <span style={{ marginLeft: 20 }}></span>
              </Col>
              <Col span={10} className="oyabuhin-detail-col" style={{ textAlign: 'left', paddingRight: 20 }}></Col>
            </Row>

            {/* 工程別 */}

            <div style={{ display: showCostOrProcess === 1 ? '' : 'none' }}>
              {props?.isIQ5 &&
                props.estimateData?.esIq5Info?.map((item, index) => {
                  const isOpen = isItemOpen(index);

                  return (
                    <div key={index}>
                      <Row
                        onClick={() => toggleItem(index)}
                        style={{ color: 'black', cursor: 'pointer' }}
                        className="oyabuhin oyabuhin-row"
                      >
                        <Col span={4} className="oyabuhin-col">
                          <div style={{ display: 'flex' }}>
                            {isOpen ? (
                              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                            ) : (
                              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                            )}
                            <label style={{ marginLeft: 5 }}>{item.name}</label>
                          </div>
                        </Col>

                        <Col span={12} className="oyabuhin-col">
                          <div>
                            <span>{`製造原価: ${item.workCostUnitPrice} 円`}</span>
                          </div>
                        </Col>
                        <Col span={8} className="oyabuhin-col"></Col>
                      </Row>

                      <div style={{ display: isOpen ? 'block' : 'none', margin: '5px' }}>
                        <Row className="registerModal">
                          {item?.processSelect?.details && item?.processSelect?.details?.length > 0 ? (
                            item.processSelect.details
                              .filter((process) => process.isUsedForCalc === true)
                              .map((process, processIndex) => {
                                const processName = getProcessName(process.processId);
                                const uniqueKey = `${index}-${processIndex}`;
                                const isProcessDetailOpen = openProcessKeys.has(uniqueKey);

                                // 段取り時間
                                const additionItem = item.additions?.find((i) => i.processId === process.processId);

                                let isAuto = 0;
                                let totalDandoriTime = 0;
                                let totalDandoriAmt = 0;
                                let totalSagyoTime = 0;
                                let totalSagyoAmt = 0;
                                //
                                let editTime = 0;
                                let autoTime = 0;
                                //
                                let editAmt = 0;
                                let autoAmt = 0;
                                //
                                let editSagyoTime = 0;
                                let autoSagyoTime = 0;
                                //
                                let editSagyoAmt = 0;
                                let autoSagyoAmt = 0;

                                if (additionItem) {
                                  isAuto = additionItem.dataType;
                                  autoTime = additionItem.dataItems?.totalDandoriTime || 0;
                                  editTime = additionItem.editItems?.totalDandoriTime || 0;
                                  autoSagyoTime = additionItem.dataItems?.totalSagyoTime || 0;
                                  editSagyoTime = additionItem.editItems?.totalSagyoTime || 0;

                                  //
                                  autoAmt = additionItem.dataItems?.totalDandoriAmt || 0;
                                  editAmt = additionItem.editItems?.totalDandoriAmt || 0;
                                  autoSagyoAmt = additionItem.dataItems?.totalSagyoAmt || 0;
                                  editSagyoAmt = additionItem.editItems?.totalSagyoAmt || 0;
                                  if (isAuto === 0) {
                                    totalDandoriTime = autoTime;
                                    totalDandoriAmt = autoAmt;
                                    //
                                    totalSagyoTime = autoSagyoTime;
                                    totalSagyoAmt = autoSagyoAmt;
                                  } else {
                                    totalDandoriTime = editTime;
                                    totalDandoriAmt = editAmt;
                                    //
                                    totalSagyoTime = editSagyoTime;
                                    totalSagyoAmt = editSagyoAmt;
                                  }
                                }

                                const isExcluded = !process?.isUsedForCalc;
                                const isManuallyOverriddenAndChangedTime = isAuto !== 0 && editTime !== autoTime;

                                const timeColor = isManuallyOverriddenAndChangedTime || isExcluded ? 'red' : 'black';

                                const isManuallyOverriddenAndChangedAmt = isAuto !== 0 && editSagyoAmt !== autoSagyoAmt;

                                const amtColor = isManuallyOverriddenAndChangedAmt || isExcluded ? 'red' : 'black';

                                //
                                const processInput = item.processInput?.find(
                                  (input) => input.processId === process.processId
                                );

                                return (
                                  <div key={processIndex} style={{ width: '100%' }}>
                                    <Row
                                      style={{ width: '100%', borderBottom: '2px solid #eeebeb', cursor: 'pointer' }}
                                      onClick={() => toggleProcessDetail(index, processIndex)}
                                    >
                                      <Col span={4} style={{ paddingLeft: 20 }}>
                                        {isProcessDetailOpen ? (
                                          <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                                        ) : (
                                          <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                                        )}
                                        <label style={{ fontWeight: 500, marginLeft: 5 }}>
                                          {processName}
                                          {(isManuallyOverriddenAndChangedTime ||
                                            isManuallyOverriddenAndChangedAmt) && (
                                            <span style={{ fontSize: '11px', color: '#999', marginLeft: 5 }}>
                                              {' ※手動入力されています'}
                                            </span>
                                          )}
                                        </label>
                                      </Col>
                                      <Col span={12} style={{ display: 'flex', marginLeft: 5 }}></Col>
                                      <Col span={8} style={{ display: 'flex', marginLeft: 5 }}></Col>
                                    </Row>

                                    <div
                                      style={{
                                        display: isProcessDetailOpen ? 'block' : 'none',
                                      }}
                                    >
                                      {processInput.deviceProcessInputDetails &&
                                      processInput.deviceProcessInputDetails?.length > 0 ? (
                                        // --- LEVEL 3 LOOP: Loop through deviceProcessInputDetails ---
                                        processInput.deviceProcessInputDetails?.map((inputDetail, inputDetailIndex) => {
                                          const inputDetailKey = `${processIndex}-${inputDetailIndex}`;
                                          const isInputDetailOpen = openInputDetailKeys.has(inputDetailKey);
                                          const deviceId = inputDetail.deviceId || 0;
                                          const deviceName = inputDetail.deviceNm || '装置名なし'; // Assuming deviceName exists on inputDetail

                                          const subDetailsList = inputDetail.details;

                                          return (
                                            <div key={inputDetailIndex} style={{ width: '100%' }}>
                                              {/* LEVEL 3 HEADER: Device Name (e.g., Laser Cutter A) - Click to open details */}
                                              <Row
                                                style={{
                                                  width: '100%',
                                                  borderBottom: '2px solid #eeebeb',
                                                  cursor: 'pointer',
                                                  paddingLeft: 40,
                                                }} // Indent!
                                                onClick={() => toggleProcessInputDetail(processIndex, inputDetailIndex)}
                                              >
                                                <Col span={10}>
                                                  {/* {isDetailOpen ? (
                                                    <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                                                  ) : ( */}
                                                  <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                                                  {/* )} */}
                                                  <label style={{ fontWeight: 400, marginLeft: 5 }}>{deviceName}</label>
                                                </Col>
                                                <Col span={10}></Col>
                                              </Row>

                                              {/* LEVEL 4 CONTAINER (The content expanded by the Level 3 click) */}
                                              <div
                                                style={{
                                                  display: isInputDetailOpen ? 'block' : 'none',
                                                  // paddingLeft: 60,
                                                }}
                                              >
                                                {subDetailsList && subDetailsList.length > 0 ? (
                                                  // --- LEVEL 4 LOOP: Loop through inputDetail.details (subDetail) ---
                                                  subDetailsList.map((subDetail, subDetailIndex) => {
                                                    const subDetailKey = `${inputDetailKey}-${subDetailIndex}`; // Key for Level 4
                                                    const isSubDetailOpen = openInputSubDetailKeys.has(subDetailKey);

                                                    const processToWorkType = {
                                                      切断: WorkType.PaSteelCut,
                                                      穴: WorkType.PaSteelHole,
                                                      切欠: WorkType.PaSteelNotch,
                                                      曲げ: WorkType.PaSteelBend,
                                                      取付: WorkType.PaSteelMount,
                                                      開先: WorkType.PaSteelGroove,
                                                      バリ取り: WorkType.PaSteelDebbur,
                                                      溶接: WorkType.PaSteelWeld,
                                                      溶接仕上: WorkType.PaSteelWeldFinish,
                                                      表面積: WorkType.PaSteelArea,
                                                      重量: WorkType.PaSteelWeight,
                                                    };

                                                    // Assign the value based on the name, fallback to a default if not found
                                                    let workType =
                                                      processToWorkType[processName] || WorkType.PaSteelCut;

                                                    const curDevice = props.deviceMasterInfo?.find(
                                                      (mst) => mst.id === process.deviceId
                                                    );
                                                    //
                                                    const curDeviceDetails = curDevice?.details;

                                                    //
                                                    const processInputDetail =
                                                      processInput.deviceProcessInputDetails?.find(
                                                        (i) => i.deviceId === process.deviceId
                                                      )?.details?.[0];

                                                    //
                                                    const estimateParameters =
                                                      props.estimateData?.estimateProducts?.calcParameters?.parameters;

                                                    let steelShape = estimateParameters?.steelShape?.filter(
                                                      (i) => i.id === item.steelShapeId
                                                    )?.[0];

                                                    let materialIq5 = estimateParameters?.materialIq5?.filter(
                                                      (m) =>
                                                        m.info.isUsed && !m.isDeleted && m.id === item?.materialIq5Id
                                                    )?.[0];

                                                    // 係数
                                                    let processingShapeCoeff = getCoeff(
                                                      curDeviceDetails?.processingShapeCoeff,
                                                      item.steelShapeId
                                                    ); //形状区分係数
                                                    let machiningMaterialCoeff = getCoeff(
                                                      curDeviceDetails?.machiningMaterialCoeff,
                                                      item.materialTypeIq5Id
                                                    ); //材質区分係数
                                                    let t1Coeff = 1;
                                                    let aCoeff = 1;
                                                    let bCoeff = 1;
                                                    let cCoeff = 1;
                                                    let processingWeightCoeff = 0;

                                                    if (steelShape?.t1) {
                                                      let t1mm = materialIq5?.info?.t1;
                                                      t1Coeff = getWeightMmCoeff(
                                                        curDeviceDetails?.t1SizeCoeffThMaster,
                                                        curDeviceDetails?.t1SizeCoeffThItems,
                                                        t1mm
                                                      ); //t1係数
                                                    }
                                                    if (steelShape?.a) {
                                                      let amm = materialIq5?.info?.a;
                                                      aCoeff = getWeightMmCoeff(
                                                        curDeviceDetails?.aSizeCoeffThMaster,
                                                        curDeviceDetails?.aSizeCoeffThItems,
                                                        amm
                                                      ); //a係数
                                                    }
                                                    if (steelShape?.b) {
                                                      let bmm = materialIq5?.info?.b;
                                                      bCoeff = getWeightMmCoeff(
                                                        curDeviceDetails?.bSizeCoeffThMaster,
                                                        curDeviceDetails?.bSizeCoeffThItems,
                                                        bmm
                                                      ); //b係数
                                                    }
                                                    if (steelShape?.c) {
                                                      let cmm = materialIq5?.info?.c;
                                                      cCoeff = getWeightMmCoeff(
                                                        curDeviceDetails?.cSizeCoeffThMaster,
                                                        curDeviceDetails?.cSizeCoeffThItems,
                                                        cmm
                                                      ); //c係数
                                                    }

                                                    if (processName !== '重量') {
                                                      //加工の重量区分係数
                                                      processingWeightCoeff = getWeightMmCoeff(
                                                        curDeviceDetails?.processingWeightCoeffThMaster,
                                                        curDeviceDetails?.processingWeightCoeffThItems,
                                                        item?.weight
                                                      );
                                                    } else {
                                                      //加工の重量区分係数
                                                      processingWeightCoeff = getWeightMmCoeff(
                                                        curDeviceDetails?.processingWeightCoeffThMaster,
                                                        curDeviceDetails?.processingWeightCoeffThItems,
                                                        subDetail?.weight
                                                      );
                                                    }

                                                    // 生産個数係数
                                                    const productionQuantityCoeff = getProductionQuantityCoeff(
                                                      curDevice,
                                                      item,
                                                      props?.estimateData
                                                    ); // 生産個数係数

                                                    const workCharge = curDeviceDetails.charges?.work;

                                                    const processMaster = props?.processMasterInfo?.filter(
                                                      (item) => item.workType === workType
                                                    )?.[0];
                                                    const processDetailTypeNo = subDetail.processDetailTypeNo;
                                                    const subDetailName =
                                                      processMaster?.details?.processDetailTypes?.filter(
                                                        (p) => p.id === processDetailTypeNo
                                                      )?.[0]?.name;

                                                    // 初期段取時間
                                                    const basicDetailTime = getBasicTime(deviceId);

                                                    // 形状区分係数
                                                    const setupShapeCoeff = getSetupShapeCoeff(
                                                      deviceId,
                                                      item.steelShapeId
                                                    );

                                                    // 材質区分係数
                                                    const materialClassificationCoeff = getMaterialClassificationCoeff(
                                                      deviceId,
                                                      item.materialTypeIq5Id
                                                    );
                                                    // 重量区分係数
                                                    const weightClassificationCoeff = getWeightClassificationCoeff(
                                                      deviceId,
                                                      item.weight
                                                    );

                                                    const detailDandoriTime =
                                                      basicDetailTime *
                                                      setupShapeCoeff *
                                                      materialClassificationCoeff *
                                                      weightClassificationCoeff;

                                                    // チャージ
                                                    const prep = props?.deviceMasterInfo?.find(
                                                      (mst) => mst.id === deviceId
                                                    ).details?.charges?.prep;
                                                    const detailDandoriAmt = ((detailDandoriTime / 60) * prep) / 60;

                                                    // 加工時間・金額
                                                    let basicSagyoDetailTime = 0;

                                                    // 切断
                                                    if (workType === WorkType.PaSteelCut) {
                                                      basicSagyoDetailTime = calculateCuttingCost(
                                                        curDevice,
                                                        processInputDetail
                                                      );
                                                    }

                                                    // 穴
                                                    else if (workType === WorkType.PaSteelHole) {
                                                      basicSagyoDetailTime = calculateHoleDetailCost(
                                                        subDetail.kindNo,
                                                        subDetail.processDetailTypeNo,
                                                        subDetail.holeLength,
                                                        curDevice,
                                                        workType
                                                      );

                                                      // basicSagyoDetailTime =
                                                      //   Number(subDetail.count) * basicSagyoDetailTime;
                                                    }

                                                    // 切欠
                                                    else if (workType === WorkType.PaSteelNotch) {
                                                      basicSagyoDetailTime = calculateNotchDetailCost(
                                                        subDetail.kindNo,
                                                        subDetail.processDetailTypeNo,
                                                        subDetail.notchLength,
                                                        curDevice,
                                                        workType
                                                      );
                                                      let kindNm =
                                                        curDevice?.details?.iQ5ManufactSizeInfo?.kinds?.filter(
                                                          (k) => k.no === subDetail.kindNo
                                                        )?.[0]?.name;

                                                      if (kindNm !== Notch_IQ5ManufactSizeKind[0]) {
                                                        basicSagyoDetailTime =
                                                          (subDetail.notchLength / basicSagyoDetailTime) * 60;
                                                      }
                                                    }
                                                    // 曲げ
                                                    else if (workType === WorkType.PaSteelBend) {
                                                      basicSagyoDetailTime = calculateBendDetailCost(
                                                        subDetail.kindNo,
                                                        subDetail.processDetailTypeNo,
                                                        subDetail.bendLength,
                                                        curDevice,
                                                        workType
                                                      );

                                                      let kindNm =
                                                        curDevice?.details?.iQ5ManufactSizeInfo?.kinds?.filter(
                                                          (k) => k.no === subDetail.kindNo
                                                        )?.[0]?.name;
                                                      if (
                                                        kindNm === Bend_IQ5ManufactSizeKind[2] ||
                                                        kindNm === Bend_IQ5ManufactSizeKind[1]
                                                      ) {
                                                        basicSagyoDetailTime =
                                                          subDetail.bendLength / basicSagyoDetailTime;
                                                      }
                                                      let rCoeff = 1;
                                                      rCoeff = getWeightMmCoeff(
                                                        curDevice?.details?.rSizeCoeffThMaster,
                                                        curDevice?.details?.rSizeCoeffThItems,
                                                        subDetail.bendSize
                                                      ); //
                                                      basicSagyoDetailTime *= rCoeff; // for Rsize
                                                    }

                                                    // 取付
                                                    else if (workType === WorkType.PaSteelMount) {
                                                      basicSagyoDetailTime = calculateMountDetailCost(
                                                        subDetail.kindNo,
                                                        subDetail.processDetailTypeNo,
                                                        subDetail.mountSize,
                                                        curDevice,
                                                        workType
                                                      );

                                                      let kindNm =
                                                        curDevice?.details?.iQ5ManufactSizeInfo?.kinds?.filter(
                                                          (k) => k.no === subDetail.kindNo
                                                        )?.[0]?.name;
                                                      if (kindNm === Mount_IQ5ManufactSizeKind[1]) {
                                                        basicSagyoDetailTime =
                                                          (subDetail.mountSize / basicSagyoDetailTime) * 60;
                                                      }
                                                    }

                                                    // 開先・バリ取り
                                                    else if (
                                                      workType === WorkType.PaSteelDebbur ||
                                                      workType === WorkType.PaSteelGroove
                                                    ) {
                                                      basicSagyoDetailTime = calculateGrooveDetailCost(
                                                        subDetail.kindNo,
                                                        subDetail.processDetailTypeNo,
                                                        subDetail.weldLength,
                                                        curDevice,
                                                        workType
                                                      );

                                                      let kindNm =
                                                        curDevice?.details?.iQ5ManufactSizeInfo?.kinds?.filter(
                                                          (k) => k.no === subDetail.kindNo
                                                        )?.[0]?.name;
                                                      let perimeter = materialIq5?.info?.perimeter;
                                                      if (
                                                        kindNm === Debbur_IQ5ManufactSizeKind[1] ||
                                                        kindNm === Groove_IQ5ManufactSizeKind[1]
                                                      ) {
                                                        basicSagyoDetailTime = (perimeter / basicSagyoDetailTime) * 60;
                                                      } else if (
                                                        kindNm === Debbur_IQ5ManufactSizeKind[2] ||
                                                        kindNm === Groove_IQ5ManufactSizeKind[2]
                                                      ) {
                                                        basicSagyoDetailTime =
                                                          (perimeter / 2 / basicSagyoDetailTime) * 60;
                                                      } else if (
                                                        kindNm === Debbur_IQ5ManufactSizeKind[3] ||
                                                        kindNm === Debbur_IQ5ManufactSizeKind[4] ||
                                                        kindNm === Groove_IQ5ManufactSizeKind[3] ||
                                                        kindNm === Groove_IQ5ManufactSizeKind[4]
                                                      ) {
                                                        basicSagyoDetailTime =
                                                          (subDetail.weldLength / basicSagyoDetailTime) * 60;
                                                      }
                                                    }

                                                    // 溶接・溶接仕上
                                                    else if (
                                                      workType === WorkType.PaSteelWeldFinish ||
                                                      workType === WorkType.PaSteelWeld
                                                    ) {
                                                      basicSagyoDetailTime = calculateWeldDetailCost(
                                                        subDetail.kindNo,
                                                        subDetail.processDetailTypeNo,
                                                        subDetail.weldLength,
                                                        curDevice,
                                                        workType
                                                      );

                                                      let kindNm =
                                                        curDevice?.details?.iQ5ManufactSizeInfo?.kinds?.filter(
                                                          (k) => k.no === subDetail.kindNo
                                                        )?.[0]?.name;
                                                      let perimeter = materialIq5?.info?.perimeter;
                                                      if (kindNm === WeldFinish_IQ5ManufactSizeKind[2]) {
                                                        basicSagyoDetailTime = (perimeter / basicSagyoDetailTime) * 60;
                                                      } else if (kindNm === WeldFinish_IQ5ManufactSizeKind[3]) {
                                                        basicSagyoDetailTime =
                                                          (perimeter / 2 / basicSagyoDetailTime) * 60;
                                                      } else if (
                                                        kindNm === WeldFinish_IQ5ManufactSizeKind[4] ||
                                                        kindNm === WeldFinish_IQ5ManufactSizeKind[5]
                                                      ) {
                                                        basicSagyoDetailTime =
                                                          (subDetail.weldLength / basicSagyoDetailTime) * 60;
                                                      }
                                                    }

                                                    // 表面積
                                                    else if (workType === WorkType.PaSteelArea) {
                                                      // 表面積
                                                      let area = subDetail?.area || 0;
                                                      let x = subDetail?.x;
                                                      let y = subDetail?.y;

                                                      let kindNm =
                                                        curDevice?.details?.iQ5ManufactSizeInfo?.kinds?.filter(
                                                          (k) => k.no === subDetail.kindNo
                                                        )?.[0]?.name;
                                                      if (kindNm === Area_IQ5ManufactSizeKind[3]) {
                                                        area = x * y * 0.01;
                                                      }

                                                      basicSagyoDetailTime = calculateAreaDetailCost(
                                                        subDetail.kindNo,
                                                        subDetail.processDetailTypeNo,
                                                        area,
                                                        curDevice,
                                                        workType
                                                      );
                                                    }

                                                    // 重量
                                                    else if (workType === WorkType.PaSteelWeight) {
                                                      basicSagyoDetailTime = calculateWeightDetailCost(
                                                        subDetail.kindNo,
                                                        subDetail.processDetailTypeNo,
                                                        subDetail.weight,
                                                        curDevice,
                                                        workType
                                                      );
                                                    }

                                                    basicSagyoDetailTime =
                                                      Number(subDetail.count) * basicSagyoDetailTime;

                                                    basicSagyoDetailTime = Math.round(basicSagyoDetailTime);

                                                    const detailSagyoTime =
                                                      basicSagyoDetailTime *
                                                      processingShapeCoeff *
                                                      machiningMaterialCoeff *
                                                      t1Coeff *
                                                      aCoeff *
                                                      bCoeff *
                                                      cCoeff *
                                                      processingWeightCoeff *
                                                      productionQuantityCoeff;

                                                    // {`(${detailSagyoTime}÷ 60) × ${workCharge}) ÷ 60 = `}
                                                    const detailSagyoAmt = ((detailSagyoTime / 60) * workCharge) / 60;

                                                    return (
                                                      <div key={subDetailIndex} style={{ width: '100%' }}>
                                                        {/* LEVEL 4 HEADER: Sub-Detail Name - Click to open Level 5 content */}
                                                        <Row
                                                          style={{
                                                            width: '100%',
                                                            borderBottom: '2px solid #eeebeb',
                                                            cursor: 'pointer',
                                                            paddingLeft: 70,
                                                          }} // Further Indent
                                                          onClick={() =>
                                                            toggleInputSubDetail(inputDetailKey, subDetailIndex)
                                                          }
                                                        >
                                                          <Col span={10}>
                                                            {isSubDetailOpen ? (
                                                              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                                                            ) : (
                                                              <CaretDownOutlined
                                                                style={{ fontSize: 18, marginTop: 2 }}
                                                              />
                                                            )}
                                                            <label style={{ marginLeft: 5 }}>
                                                              {subDetailName ? subDetailName : processName + '①'}
                                                            </label>
                                                          </Col>
                                                          <Col span={10}></Col>
                                                        </Row>

                                                        {/* LEVEL 5 DETAIL CONTENT */}
                                                        <div
                                                          style={{
                                                            display: isSubDetailOpen ? 'block' : 'none',
                                                            paddingLeft: 10,
                                                            paddingBottom: 5,
                                                            backgroundColor: '#fff',
                                                          }}
                                                        >
                                                          {/* Final deepest content */}
                                                          {/* <label style={{ fontSize: '11px', color: '#666' }}>
                                                            データ: {JSON.stringify(subDetail)}
                                                          </label> */}
                                                          <Row
                                                            style={{
                                                              width: '100%',
                                                              borderBottom: '2px solid #eeebeb',
                                                              cursor: 'pointer',
                                                            }}
                                                          >
                                                            <Col span={4} style={{ paddingTop: 10, paddingLeft: 70 }}>
                                                              <div
                                                                style={{
                                                                  borderBottom: '2px solid #eeebeb',
                                                                  paddingBottom: 4,
                                                                }}
                                                              >
                                                                <label>{'段取時間'}</label>
                                                              </div>

                                                              <div
                                                                style={{
                                                                  borderBottom: '2px solid #eeebeb',
                                                                  paddingBottom: 4,
                                                                }}
                                                              >
                                                                <label>{'段取金額'}</label>
                                                              </div>

                                                              <div
                                                                style={{
                                                                  borderBottom: '2px solid #eeebeb',
                                                                  paddingBottom: 4,
                                                                }}
                                                              >
                                                                <label>{'加工時間'}</label>
                                                              </div>

                                                              <div
                                                                style={{
                                                                  borderBottom: '2px solid #eeebeb',
                                                                  paddingBottom: 4,
                                                                }}
                                                              >
                                                                <label>{'加工金額'}</label>
                                                              </div>
                                                            </Col>
                                                            <Col span={12} style={{ paddingTop: 10 }}>
                                                              <div
                                                                style={{
                                                                  borderBottom: '2px solid #eeebeb',
                                                                  paddingBottom: 4,
                                                                }}
                                                              >
                                                                <Typography.Text
                                                                  ellipsis={{
                                                                    tooltip:
                                                                      '初期段取時間×形状区分係数×材質区分係数×重量区分係数',
                                                                  }}
                                                                >
                                                                  {
                                                                    '初期段取時間×形状区分係数×材質区分係数×重量区分係数'
                                                                  }
                                                                </Typography.Text>
                                                              </div>

                                                              <div
                                                                style={{
                                                                  borderBottom: '2px solid #eeebeb',
                                                                  paddingBottom: 4,
                                                                }}
                                                              >
                                                                <label>{'((段取時間 ÷ 60) × チャージ) ÷ 60'}</label>
                                                              </div>

                                                              <div
                                                                style={{
                                                                  borderBottom: '2px solid #eeebeb',
                                                                  paddingBottom: 4,
                                                                }}
                                                              >
                                                                <Typography.Text
                                                                  ellipsis={{
                                                                    tooltip:
                                                                      '1回の加工時間×形状区分係数×材質区分係数×T1係数×A係数×B係数×C係数×重量係数×生産工数係数',
                                                                  }}
                                                                >
                                                                  {
                                                                    '1回の加工時間×形状区分係数×材質区分係数×T1係数×A係数×B係数×C係数×重量係数×生産工数係数'
                                                                  }
                                                                </Typography.Text>
                                                              </div>

                                                              <div
                                                                style={{
                                                                  borderBottom: '2px solid #eeebeb',
                                                                  paddingBottom: 4,
                                                                }}
                                                              >
                                                                <label>{'((段取時間 ÷ 60) × チャージ) ÷ 60'}</label>
                                                              </div>
                                                            </Col>
                                                            <Col span={8} style={{ paddingTop: 10 }}>
                                                              <div
                                                                style={{
                                                                  borderBottom: '2px solid #eeebeb',
                                                                  paddingBottom: 4,
                                                                }}
                                                              >
                                                                <label>
                                                                  {`${Math.round(
                                                                    basicDetailTime
                                                                  )} × ${setupShapeCoeff} × ${materialClassificationCoeff} × ${weightClassificationCoeff} = `}
                                                                  <span
                                                                    style={{ color: timeColor, fontWeight: 'bold' }}
                                                                  >
                                                                    {`${Math.round(detailDandoriTime)} (${secondsToHms(
                                                                      detailDandoriTime
                                                                    )})`}
                                                                  </span>
                                                                </label>
                                                              </div>

                                                              <div
                                                                style={{
                                                                  borderBottom: '2px solid #eeebeb',
                                                                  paddingBottom: 4,
                                                                }}
                                                              >
                                                                <label>
                                                                  {`((${detailDandoriTime} ÷ 60) × ${prep}) ÷ 60 = `}
                                                                  <span
                                                                    style={{ color: timeColor, fontWeight: 'bold' }}
                                                                  >
                                                                    {JPYs.format(Math.round(detailDandoriAmt))}
                                                                  </span>
                                                                </label>
                                                              </div>

                                                              <div
                                                                style={{
                                                                  borderBottom: '2px solid #eeebeb',
                                                                  paddingBottom: 4,
                                                                }}
                                                              >
                                                                <label>
                                                                  {`${Math.round(
                                                                    basicSagyoDetailTime
                                                                  )} × ${processingShapeCoeff} × ${machiningMaterialCoeff} × ${t1Coeff} × ${aCoeff} × ${bCoeff} × ${cCoeff} × ${processingWeightCoeff} × ${productionQuantityCoeff} = `}
                                                                  <span style={{ color: amtColor, fontWeight: 'bold' }}>
                                                                    {`${Math.round(detailSagyoTime)} (${secondsToHms(
                                                                      detailSagyoTime
                                                                    )})`}
                                                                  </span>
                                                                </label>
                                                              </div>

                                                              <div
                                                                style={{
                                                                  borderBottom: '2px solid #eeebeb',
                                                                  paddingBottom: 4,
                                                                }}
                                                              >
                                                                <label>
                                                                  {`(${Math.round(
                                                                    detailSagyoTime
                                                                  )}÷ 60) × ${workCharge}) ÷ 60 = `}
                                                                  <span style={{ color: amtColor, fontWeight: 'bold' }}>
                                                                    {JPYs.format(Math.round(detailSagyoAmt))}
                                                                  </span>
                                                                </label>
                                                              </div>
                                                            </Col>
                                                          </Row>
                                                        </div>
                                                      </div>
                                                    );
                                                  })
                                                ) : (
                                                  <div style={{ paddingLeft: 20, color: '#c3c3c3', padding: 5 }}>
                                                    詳細データはありません。
                                                  </div>
                                                )}
                                              </div>

                                              {/* LEVEL 4 DETAIL CONTENT */}
                                              <div
                                                style={{
                                                  display: isInputDetailOpen ? 'block' : 'none',
                                                  paddingLeft: 60,
                                                  paddingBottom: 5,
                                                  backgroundColor: '#f9f9f9',
                                                }}
                                              ></div>
                                            </div>
                                          );
                                        })
                                      ) : (
                                        <div style={{ paddingLeft: 20, color: '#aaa', padding: 10 }}>
                                          入力装置情報はありません。
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                );
                              })
                          ) : (
                            <Col span={24} style={{ paddingLeft: 20, color: '#aaa' }}>
                              工程情報はありません。
                            </Col>
                          )}
                        </Row>
                      </div>
                    </div>
                  );
                })}

              {/* IQ3 */}
              {props?.isIQ3 &&
                props.estimateData?.esIq3Info?.map((item, index) => {
                  const isOpen = isItemOpen(index);
                  return (
                    <div key={index}>
                      <Row
                        onClick={() => toggleItem(index)}
                        style={{ color: 'black', cursor: 'pointer' }}
                        className="oyabuhin oyabuhin-row"
                      >
                        <Col span={4} className="oyabuhin-col">
                          <div style={{ display: 'flex' }}>
                            {isOpen ? (
                              <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                            ) : (
                              <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                            )}
                            <label style={{ marginLeft: 5 }}>{item.name}</label>
                          </div>
                        </Col>

                        <Col span={12} className="oyabuhin-col">
                          <div>
                            <span>{`製造原価: ${Math.round(item.workCostUnitPrice)} 円`}</span>
                          </div>
                        </Col>
                        <Col span={8} className="oyabuhin-col"></Col>
                      </Row>

                      <div style={{ display: isOpen ? 'block' : 'none', margin: '5px' }}>
                        <Row className="mt-1 registerModal">
                          {item?.processSelect?.details && item?.processSelect?.details?.length > 0 ? (
                            item.processSelect.details
                              .filter((process) => process.isUsedForCalc === true)
                              .map((process, processIndex) => {
                                const processName = getProcessName(process.processId);
                                const uniqueKey = `${index}-${processIndex}`;
                                const isProcessDetailOpen = openProcessKeys.has(uniqueKey);

                                //
                                const processInput = item.processInput?.find(
                                  (input) => input.processId === process.processId
                                );

                                let processMst = [];
                                let deviceMst = [];

                                // deviceMst
                                const parameters = props?.estimateData?.estimateProducts?.calcParameters?.parameters;
                                if (parameters?.process?.length > 0) {
                                  processMst = parameters?.process?.filter(
                                    (item) => item?.class === ServiceClass.SheetMetal
                                  );

                                  if (processName === 'プログラム') {
                                    processMst = processMst
                                      ? processMst?.filter((p) => p.workType === WorkType.SmProgram)[0]
                                      : [];
                                  } else if (processName === '検査') {
                                    processMst = processMst
                                      ? processMst?.filter((item) => item.workType === WorkType.SmInspection)[0]
                                      : [];
                                  } else if (processName === 'シャーリング') {
                                    processMst = processMst
                                      ? processMst?.filter((item) => item.workType === WorkType.SmShearing)[0]
                                      : [];
                                  } else if (processName === 'ベンディング') {
                                    processMst = processMst
                                      ? processMst?.filter((item) => item.workType === WorkType.SmBending)[0]
                                      : [];
                                  } else if (processName === 'レーザー') {
                                    processMst = processMst
                                      ? processMst?.filter((item) => item.workType === WorkType.SmBlankLaser)[0]
                                      : [];
                                  } else if (processName === 'パンチ') {
                                    processMst = processMst
                                      ? processMst?.filter((item) => item.workType === WorkType.SmBlankPunch)[0]
                                      : [];
                                  } else if (processName === '複合機') {
                                    processMst = processMst
                                      ? processMst?.filter((item) => item.workType === WorkType.SmBlankCombi)[0]
                                      : [];
                                  } else if (processName === '手動バリ') {
                                    processMst = processMst
                                      ? processMst?.filter((item) => item.workType === WorkType.SmDeburringManual)[0]
                                      : [];
                                  } else if (processName === '自動バリ') {
                                    processMst = processMst
                                      ? processMst?.filter((item) => item.workType === WorkType.SmDeburringAuto)[0]
                                      : [];
                                  } else if (processName === '溶接') {
                                    processMst = processMst
                                      ? processMst?.filter((item) => item.workType === WorkType.SmWelding)[0]
                                      : [];
                                  } else if (processName === '溶接仕上') {
                                    processMst = processMst
                                      ? processMst?.filter((item) => item.workType === WorkType.SmWeldFinish)[0]
                                      : [];
                                  } else if (processName === '表面処理') {
                                    processMst = processMst
                                      ? processMst?.filter((item) => item.workType === WorkType.SmSurface)[0]
                                      : [];
                                  } else if (processName === '2次加工') {
                                    processMst = processMst
                                      ? processMst?.filter((item) => item.workType === WorkType.SmSecondaryWork)[0]
                                      : [];
                                  } else if (processName.includes('追加工程')) {
                                    processMst = processMst
                                      ? processMst?.filter((item) => item.workType === WorkType.SmCustom)[0]
                                      : [];
                                  }

                                  if (parameters?.device?.length > 0) {
                                    deviceMst = parameters?.device?.filter((j) => processMst?.id == j?.processId);
                                  }
                                }

                                let patternInfo = item?.processSelect
                                  ? item?.processSelect?.details?.filter((i) => i.processId == processMst?.id)
                                  : [];

                                deviceMst =
                                  deviceMst && patternInfo
                                    ? deviceMst?.filter(
                                        (item) =>
                                          item.processId == patternInfo[0]?.processId &&
                                          item.id == patternInfo[0]?.deviceId
                                      )[0]
                                    : [];

                                let dandoriTimeSec = 0;
                                let dandoriAmt = 0;
                                let cSagyoTimeSec = 0;
                                let cSagyoAmt = 0;

                                // プログラム
                                let dataItems_elementCnt = 0;
                                let mSetHRate = 0;
                                let workBasicTime = 0;
                                let otherElementCoeffThMaster = 0;
                                let otherElementCoeffThMasterCnt = 0;
                                let workTimeElementCoeff = 0;
                                let mWorkHRate = 0;

                                // 検査
                                // サイズ係数
                                let partsCoeff = 0;
                                let processCount = 0;
                                let processTime = 0;
                                let basicDantoriTime = 0;

                                // シャーリング
                                //カット数
                                let cutTime = 0;

                                if (processName === 'プログラム') {
                                  dataItems_elementCnt = parseInt(processInput?.details?.[0]?.elements);

                                  mSetHRate = deviceMst.details?.charges.prep;
                                  dandoriTimeSec = calDandoriTime(dataItems_elementCnt, deviceMst);
                                  dandoriAmt = calDandoriAmt(dandoriTimeSec, mSetHRate);
                                  dandoriAmt = JPYs.format(Math.round(dandoriAmt));

                                  //1要素当たりの作業時間
                                  workBasicTime = deviceMst?.details?.workBasicTime;
                                  // 要素数 dataItems_elementCnt

                                  //
                                  // 係数
                                  otherElementCoeffThMaster = deviceMst?.details?.otherElementCoeffThMaster?.filter(
                                    (item) =>
                                      (item.value == dataItems_elementCnt || item.value > dataItems_elementCnt) &&
                                      !item?.isOutOfRange
                                  );
                                  otherElementCoeffThMasterCnt =
                                    otherElementCoeffThMaster?.length > 0
                                      ? otherElementCoeffThMaster[0]?.no
                                      : deviceMst?.details?.otherElementCoeffThMaster[0]?.no;
                                  // 作業時間係数
                                  workTimeElementCoeff =
                                    otherElementCoeffThMasterCnt == 0
                                      ? 0
                                      : deviceMst?.details?.workTimeElementCoeffThItems?.filter(
                                          (item) => item.no == otherElementCoeffThMasterCnt && !item.isOutOfRange
                                        )[0]?.value;
                                  cSagyoTimeSec = calSagyoTime(
                                    dataItems_elementCnt,
                                    workBasicTime,
                                    workTimeElementCoeff
                                  );

                                  //装置の作業時間チャージ
                                  mWorkHRate = deviceMst.details?.charges.work;
                                  cSagyoAmt = calSagyoAmt(cSagyoTimeSec, mWorkHRate);
                                  cSagyoAmt = JPYs.format(Math.round(cSagyoAmt));
                                } else if (processName === '検査') {
                                  // 重量
                                  let weight = item?.weight;

                                  // 面積
                                  let area = Number(item?.totalSurfaceArea);

                                  // 重量
                                  let childPartsCoeffWeightThMaster =
                                    deviceMst?.details?.childPartsCoeffWeightThMaster?.filter(
                                      (item) => (item.value == weight || item.value > weight) && !item?.isOutOfRange
                                    );
                                  // 面積
                                  let childPartsCoeffAreaThMaster =
                                    deviceMst?.details?.childPartsCoeffAreaThMaster?.filter(
                                      (item) => (item.value == area || item.value > area) && !item?.isOutOfRange
                                    );
                                  let childPartsCoeffs =
                                    childPartsCoeffWeightThMaster?.length > 0 && childPartsCoeffAreaThMaster?.length > 0
                                      ? deviceMst?.details?.childPartsCoeff?.filter(
                                          (item) => item.weightId == childPartsCoeffWeightThMaster[0]?.no
                                        )
                                      : deviceMst?.details?.childPartsCoeff[0];

                                  // サイズ係数
                                  partsCoeff =
                                    childPartsCoeffs?.length > 0
                                      ? childPartsCoeffs?.[0]?.areaCoeffList?.filter(
                                          (item) =>
                                            item.no == childPartsCoeffAreaThMaster?.[0].no && !item?.isOutOfRange
                                        )?.[0]?.value
                                      : childPartsCoeffs?.[0]?.areaCoeffList?.[0]?.value;

                                  //　基本段取時間＊サイズ係数
                                  dandoriTimeSec = deviceMst?.details?.prepBasicTime * partsCoeff;
                                  dandoriTimeSec = dandoriTimeSec ? dandoriTimeSec : 0;

                                  //装置の段階時間チャージ
                                  mSetHRate = deviceMst.details?.charges.prep;
                                  dandoriAmt = calDandoriAmt(dandoriTimeSec, mSetHRate);

                                  // 検査工程入力情報取得
                                  let kensaProcessInput = item?.processInput?.filter(
                                    (item) => item.processId == processMst?.id
                                  )[0];

                                  //検査箇所
                                  processCount = Number(kensaProcessInput?.details?.[0]?.numOfCuts);

                                  cSagyoTimeSec = deviceMst?.details?.prepBasicTime * partsCoeff * processCount;

                                  //装置の作業時間チャージ
                                  mWorkHRate = deviceMst.details?.charges.work;
                                  // 作業金額
                                  //　作業時間＊時間チャージ
                                  cSagyoAmt = calSagyoAmt(cSagyoTimeSec, mWorkHRate);

                                  processTime = deviceMst?.details?.inspectionWorkTime;
                                } else if (processName === 'シャーリング') {
                                  // // 重量
                                  // let weight = item?.weight;
                                  // // 面積
                                  // let area = Number(item?.totalSurfaceArea);

                                  // 段取時間設定
                                  //　基本段取時間
                                  dandoriTimeSec = deviceMst?.details?.prepBasicTime
                                    ? deviceMst?.details?.prepBasicTime
                                    : 0;

                                  //装置の段階時間チャージ
                                  mSetHRate = deviceMst.details?.charges.prep;

                                  // 段階時間＊時間チャージ
                                  dandoriAmt = calDandoriAmt(dandoriTimeSec, mSetHRate);
                                  dandoriAmt = JPYs.format(Math.round(dandoriAmt));

                                  // シャーリング工程入力情報取得
                                  let shirringProcessInput = item?.processInput?.filter(
                                    (i) => i.processId == processMst?.id
                                  )[0];

                                  //カット数
                                  processCount = Number(shirringProcessInput?.details?.[0]?.numOfCuts);

                                  // 作業時間
                                  // １カット時間
                                  cutTime = deviceMst?.details?.cutTime;
                                  // １カット時間＊カット数
                                  cSagyoTimeSec = cutTime * processCount;

                                  //装置の作業時間チャージ
                                  mWorkHRate = deviceMst.details?.charges.work;

                                  // 作業金額
                                  //　作業時間＊時間チャージ
                                  cSagyoAmt = calSagyoAmt(cSagyoTimeSec, mWorkHRate);
                                  cSagyoAmt = JPYs.format(Math.round(cSagyoAmt));
                                }

                                return (
                                  <div key={processIndex} style={{ width: '100%' }}>
                                    <Row
                                      style={{ width: '100%', borderBottom: '2px solid #eee', cursor: 'pointer' }}
                                      onClick={() => toggleProcessDetail(index, processIndex)}
                                    >
                                      <Col span={4} style={{ paddingLeft: 20 }}>
                                        {isProcessDetailOpen ? (
                                          <CaretUpOutlined style={{ fontSize: 18, marginTop: 2 }} />
                                        ) : (
                                          <CaretDownOutlined style={{ fontSize: 18, marginTop: 2 }} />
                                        )}
                                        <label style={{ fontWeight: 500, marginLeft: 5 }}>
                                          {processName}
                                          {/* {(isManuallyOverriddenAndChangedTime ||
                                            isManuallyOverriddenAndChangedAmt) && (
                                            <span style={{ fontSize: '11px', color: '#999', marginLeft: 5 }}>
                                              {' ※手動入力されています'}
                                            </span>
                                          )} */}
                                        </label>
                                      </Col>
                                      <Col span={12} style={{ display: 'flex', marginLeft: 5 }}></Col>
                                      <Col span={8} style={{ display: 'flex', marginLeft: 5 }}></Col>
                                    </Row>

                                    <div
                                      style={{
                                        display: isProcessDetailOpen ? 'block' : 'none',
                                      }}
                                    >
                                      {processName === 'プログラム' && (
                                        <div>
                                          <IQ3KouteiBetsuKesanshiki_Program
                                            dandoriTimeSec={dandoriTimeSec}
                                            dandoriAmt={dandoriAmt}
                                            cSagyoTimeSec={cSagyoTimeSec}
                                            cSagyoAmt={cSagyoAmt}
                                            dataItems_elementCnt={dataItems_elementCnt}
                                            mSetHRate={mSetHRate}
                                            mWorkHRate={mWorkHRate}
                                            workBasicTime={workBasicTime}
                                            otherElementCoeffThMaster={otherElementCoeffThMaster}
                                            otherElementCoeffThMasterCnt={otherElementCoeffThMasterCnt}
                                            workTimeElementCoeff={workTimeElementCoeff}
                                          />
                                        </div>
                                      )}
                                      {processName === '検査' && (
                                        <div>
                                          <IQ3KouteiBetsuKesanshiki_Kensa
                                            dandoriTimeSec={dandoriTimeSec}
                                            dandoriAmt={dandoriAmt}
                                            cSagyoTimeSec={cSagyoTimeSec}
                                            cSagyoAmt={cSagyoAmt}
                                            processCount={processCount}
                                            processTime={processTime}
                                            mSetHRate={mSetHRate}
                                            mWorkHRate={mWorkHRate}
                                          />
                                        </div>
                                      )}
                                      {processName === 'シャーリング' && (
                                        <div>
                                          <IQ3KouteiBetsuKesanshiki_Shirring
                                            dandoriTimeSec={dandoriTimeSec}
                                            dandoriAmt={dandoriAmt}
                                            cSagyoTimeSec={cSagyoTimeSec}
                                            cSagyoAmt={cSagyoAmt}
                                            processCount={processCount}
                                            mSetHRate={mSetHRate}
                                            mWorkHRate={mWorkHRate}
                                            cutTime={cutTime}
                                          />
                                        </div>
                                      )}
                                      {processName === 'ベンディング' && (
                                        <div>
                                          <IQ3KouteiBetsuKesanshiki_Bending
                                            bendData={item}
                                            deviceMst={deviceMst}
                                            processMst={processMst}
                                            parameters={parameters}
                                          />
                                        </div>
                                      )}
                                      {processName === 'レーザー' && (
                                        <div>
                                          <IQ3KouteiBetsuKesanshiki_Laser
                                            laserData={item}
                                            deviceMst={deviceMst}
                                            processMst={processMst}
                                            parameters={parameters}
                                            estimateData={props.estimateData}
                                            settingInfo={props?.settingInfo}
                                          />
                                        </div>
                                      )}
                                      {processName === '複合機' && (
                                        <div>
                                          <IQ3KouteiBetsuKesanshiki_Laser
                                            laserData={item}
                                            deviceMst={deviceMst}
                                            processMst={processMst}
                                            parameters={parameters}
                                            estimateData={props.estimateData}
                                            settingInfo={props?.settingInfo}
                                          />
                                        </div>
                                      )}
                                      {processName === 'パンチ' && (
                                        <div>
                                          <IQ3KouteiBetsuKesanshiki_BlankPunch
                                            punchData={item}
                                            deviceMst={deviceMst}
                                            processMst={processMst}
                                            parameters={parameters}
                                            estimateData={props.estimateData}
                                            settingInfo={props?.settingInfo}
                                          />
                                        </div>
                                      )}
                                      {processName === '手動バリ' && (
                                        <div>
                                          <IQ3KouteiBetsuKesanshiki_MenualBari
                                            menualBariData={item}
                                            deviceMst={deviceMst}
                                            processMst={processMst}
                                            parameters={parameters}
                                            estimateData={props.estimateData}
                                            settingInfo={props?.settingInfo}
                                          />
                                        </div>
                                      )}
                                      {processName === '自動バリ' && (
                                        <div>
                                          <IQ3KouteiBetsuKesanshiki_AutoBari
                                            autoBariData={item}
                                            deviceMst={deviceMst}
                                            processMst={processMst}
                                            parameters={parameters}
                                            estimateData={props.estimateData}
                                            settingInfo={props?.settingInfo}
                                          />
                                        </div>
                                      )}
                                      {processName === '溶接' && (
                                        <div>
                                          <IQ3KouteiBetsuKesanshiki_Yosetsu
                                            yosetsuData={item}
                                            deviceMst={deviceMst}
                                            processMst={processMst}
                                            parameters={parameters}
                                            estimateData={props.estimateData}
                                            settingInfo={props?.settingInfo}
                                          />
                                        </div>
                                      )}
                                      {processName === '溶接仕上' && (
                                        <div>
                                          <IQ3KouteiBetsuKesanshiki_YosetsuFinish
                                            yosetsuData={item}
                                            deviceMst={deviceMst}
                                            processMst={processMst}
                                            parameters={parameters}
                                            estimateData={props.estimateData}
                                            settingInfo={props?.settingInfo}
                                          />
                                        </div>
                                      )}
                                      {processName === '表面処理' && (
                                        <div>
                                          <IQ3KouteiBetsuKesanshiki_Hyoumen
                                            hyoumenData={item}
                                            deviceMst={deviceMst}
                                            processMst={processMst}
                                            parameters={parameters}
                                            estimateData={props.estimateData}
                                            settingInfo={props?.settingInfo}
                                          />
                                        </div>
                                      )}
                                      {processName === '2次加工' && (
                                        <div>
                                          <IQ3KouteiBetsuKesanshiki_2jikakou
                                            data={item}
                                            deviceMst={deviceMst}
                                            processMst={processMst}
                                            parameters={parameters}
                                            estimateData={props.estimateData}
                                            settingInfo={props?.settingInfo}
                                          />
                                        </div>
                                      )}
                                      {processName.includes('追加工程') && (
                                        <div>
                                          <IQ3KouteiBetsuKesanshiki_AdditionalProcess
                                            data={item}
                                            deviceMst={deviceMst}
                                            processMst={processMst}
                                            parameters={parameters}
                                            estimateData={props.estimateData}
                                            settingInfo={props?.settingInfo}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                );
                              })
                          ) : (
                            <Col span={24} style={{ paddingLeft: 20, color: '#aaa' }}>
                              工程情報はありません。
                            </Col>
                          )}
                        </Row>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        <Row
          justify="end"
          style={{
            marginBottom: 0,
            marginTop: 5,
          }}
        >
          <Button className="mainButton" onClick={props?.detailDialogOk} style={{ marginRight: 5 }}>
            OK
          </Button>
          <Button className="cancelButton" onClick={props?.detailDialogCancel}>
            キャンセル
          </Button>
        </Row>
      </Modal>
    )
  );
};

export default EstimateFormulaModal;
